// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__88coh","inputWrap":"CustomTip_inputWrap__1gwCQ"};